module.exports = __webpack_public_path__ + "img/pecans-bg-1200w.727de013.jpg";